
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-the-quran",
      function () {
        return require("private-next-pages/about-the-quran/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-the-quran"])
      });
    }
  